<div class="tw-flex tw-w-full tw-p-2 tw-bg-color-surface-card dark:tw-bg-transparent tw-min-w-80">
  <div
    class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-p-4 tw-shadow-elevation-card tw-rounded-2xl tw-border today-account-card-inner"
  >
    <!-- Icon -->
    <div
      class="tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-xl tw-bg-dt-surface-elevated"
    >
      <div class="tw-flex tw-justify-center tw-items-center tw-w-9 tw-h-9">
        @if (square_logo_url && square_logo_url !== "") {
          <img [src]="square_logo_url" class="tw-w-full tw-h-full tw-object-contain" alt="icon" />
        } @else {
          <div class="tw-flex tw-w-full tw-h-full tw-rounded-full tw-overflow-hidden">
            <svg class="tw-w-full tw-h-full">
              <use [attr.xlink:href]="'images/sprite.svg#' + icon" />
            </svg>
          </div>
        }
      </div>
    </div>

    <!-- Name and Account Info -->
    <div class="tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-gap-1">
      <span
        class="tw-text-base tw-font-medium tw-line-clamp-1 tw-text-wrap tw-text-color-text-default"
        >{{ name }}</span
      >
      @if (accountProductName || (interestRate && isValidNumber(interestRate))) {
        <span class="tw-text-sm tw-text-color-text-tertiary tw-line-clamp-1">
          @if (accountProductName) {
            {{ accountProductName }}
          }
          @if (accountProductName && interestRate && isValidNumber(interestRate)) {
            <span> </span>
          }
          @if (interestRate && isValidNumber(interestRate)) {
            <span>({{ interestRate | number: "1.2-2" }}% p.a.)</span>
          }
        </span>
      }
    </div>

    <div class="tw-flex tw-gap-6">
      <!-- Balance -->
      <div class="tw-flex-shrink-0 tw-flex tw-items-center tw-gap-1">
        <span
          class="tw-text-base tw-font-semibold"
          [ngClass]="{
            'tw-text-dt-text-in-primary': balance > 0.01,
            'tw-text-dt-text-secondary': balance >= -0.01 && balance <= 0.01,
            'tw-text-dt-text-out-primary': balance < -0.01,
          }"
        >
          @if (isEyeOpen) {
            {{ balance | number: "1.2-2" }}
          } @else {
            <span class="tw-text-base tw-font-semibold tw-text-color-text-default"> **** </span>
          }
        </span>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-tertiary tw-uppercase">
          {{ currency }}
        </span>
      </div>

      <!-- Chevron -->
      <div class="tw-flex-shrink-0 tw-flex tw-items-center">
        <svg class="tw-text-color-text-default tw-h-5 tw-w-5">
          <use [attr.xlink:href]="'images/sprite.svg#right-arrow'" />
        </svg>
      </div>
    </div>
  </div>
</div>
